export function logoSlider() {
    let $sliderContainer = $(".logo-slider").parent();

    if ($sliderContainer.length) {
        $sliderContainer.each(function () {
            let $parentContainer = $(this);
            let $sliderDots;
            let $sliderNav = $parentContainer.find(".logo-slider-nav");
            let $activeSlide = $parentContainer.find(".active-slide");
            let $totalSlides = $parentContainer.find(".total-slides");
            let $slides = $parentContainer.find(".slider-item");
            let $slider = $parentContainer.find(".logo-slider");

            let setCounter = function (activeNumber) {
                $activeSlide.html(activeNumber);
                $totalSlides.html($slides.length);
            };

            if ($slides.length > 1) {
                $slider.slick({
                    infinite: false,
                    arrows: true,
                    dots: true,
                    slidesToShow: 1,
                    mobileFirst: true,
                    appendArrows: $(this).find(".logo-slider-nav"),
                    responsive: [
                        {
                            breakpoint: 567,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                    ],
                }).on("init reInit afterChange", function (event, slick, currentSlide, nextSlide) {
                    $sliderDots = $parentContainer.find(".slick-dots");
                    if ($sliderDots.length) {
                        $sliderNav.show();
                        $activeSlide.html($sliderDots.find("li.slick-active").index() + 1);
                        $totalSlides.html($sliderDots.find("li").length);
                    } else {
                        $sliderNav.hide();
                    }
                });
                $sliderDots = $parentContainer.find(".slick-dots");
                if ($sliderDots.length) {
                    $sliderNav.show();
                    $activeSlide.html($sliderDots.find("li.slick-active").index() + 1);
                    $totalSlides.html($sliderDots.find("li").length);
                } else {
                    $sliderNav.hide();
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/logoSlider.js